import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Form, Dropdown, Loader, Dimmer } from 'semantic-ui-react';
import { makePost } from '../services/ServiceManager';

const Container = styled.div`
  max-width: 50%;
  min-width: 50%;
`;

class ChromeData extends Component {
  constructor() {
    super();
    this.state = {
      vin: '',
      year: '',
      make: '',
      model: '', // division
      bodyType: '',
      carData: [],
      images: [], // jellybean images -> could potentially use placeholder images for the time being
      styleID: '',
      screen: 'initial',
      title: '',
      percentage: 0,
      error: null,
      confirm: false,
      width: 0,
      height: 0,
      yearArr: [],
      makeArr: [],
      modelArr: [],
      bodyTypeArr: [],
      yearsLoading: false
    };
  }

  componentDidMount() {
    const { setSectionTitle } = this.props;
    if (setSectionTitle) setSectionTitle('Chrome Data Preview');

    this.getAvailableYears();
  }

  componentWillUnmount() {}

  onSubmitButtonClick = (event) => {
    event.preventDefault();

    this.onSubmit();
  };

  onSubmitButtonClickYMMT = (event) => {
    event.preventDefault();

    this.onSubmitYMMT();
  };

  onClearButtonClick = (event) => {
    event.preventDefault();

    this.onClear();
  };

  onSubmit = async () => {
    const { vin, year, make, model, bodyType } = this.state;

    const submitJSON = {
      vin,
      year,
      make,
      model,
      bodyType
    };
    const operation = 'chromedata/images/vin';

    try {
      const resultJson = await makePost(operation, submitJSON);

      console.log('result', resultJson);
      if (resultJson.statusCode !== 200) {
        this.setState({
          screen: 'error'
        });
      } else {
        this.setState({
          screen: 'preview',
          images: resultJson.images,
          year: resultJson.year,
          make: resultJson.make,
          model: resultJson.model,
          bodyType: resultJson.trim
        });
      }
    } catch (err) {
      this.setState({
        screen: 'error'
      });
      console.log(err);
    }
  };

  onSubmitYMMT = async () => {
    const { year, make, model, bodyType } = this.state;

    const submitJSON = {
      vin: '',
      year,
      make,
      model,
      bodyType
    };
    const operation = 'chromedata/images/vin';

    try {
      const resultJson = await makePost(operation, submitJSON);

      console.log('result', resultJson);
      if (resultJson.statusCode !== 200) {
        this.setState({
          screen: 'error'
        });
      } else {
        this.setState({
          screen: 'preview',
          images: resultJson.images
        });
      }
    } catch (err) {
      this.setState({
        screen: 'error'
      });
      console.log(err);
    }
  };

  allRequired = () => {
    let res = true;
    if (
      this.state.vin.length === 17 ||
      (this.state.year && this.state.model && this.state.make)
    ) {
      res = true;
      return res;
    }
    res = false;
    return res;
  };

  onClear = () => {
    this.setState(
      {
        vin: '',
        year: '',
        make: '',
        model: '', // division
        bodyType: '', // trim
        carData: [],
        images: [],
        styleID: '',
        screen: 'initial',
        title: '',
        percentage: 0,
        error: null,
        confirm: false,
        width: 0,
        height: 0,
        yearArr: [],
        makeArr: [],
        modelArr: [],
        bodyTypeArr: []
      },
      () => {
        this.getAvailableYears();
      }
    );
  };

  handleVinChange = ({ target: { value } }) => {
    const newVal = value.trim();
    this.setState({
      vin: newVal
    });
  };

  handleYearChange = ({ target: { value } }) => {
    const newVal = value.trim();
    this.setState({
      year: newVal
    });
  };

  handleMakeChange = ({ target: { value } }) => {
    const newVal = value.replace(/ /g, '%20');
    this.setState({
      make: newVal
    });
  };

  handleModelChange = ({ target: { value } }) => {
    const newVal = value.replace(/ /g, '%20');
    this.setState({
      model: newVal
    });
  };

  handleBodyChange = ({ target: { value } }) => {
    const newVal = value.replace(/ /g, '%20');
    this.setState({
      bodyType: newVal
    });
  };

  getAvailableYears = async () => {
    const submitJSON = {
      year: '',
      make: '',
      model: '',
      bodyType: '',
      screen: 'initial'
    };
    const operation = 'chromedata/fields';

    try {
      this.setState(
        {
          ...this.state,
          yearsLoading: true
        },
        async () => {
          const resultJson = await makePost(operation, submitJSON);
          if (resultJson.statusCode !== 200) {
            this.setState({
              screen: 'error'
            });
          } else {
            const yearMap = resultJson.years.map(function(yearObj) {
              return { key: yearObj, text: yearObj, value: yearObj };
            });
            this.setState({
              ...this.state,
              yearArr: yearMap,
              makeArr: [],
              modelArr: [],
              bodyTypeArr: [],
              yearsLoading: false
            });
          }
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  getAvailableMakes = async () => {
    const { year } = this.state;
    const submitJSON = {
      year,
      make: '',
      model: '',
      bodyType: '',
      screen: 'initial'
    };
    if (year !== '') {
      const operation = 'chromedata/fields';

      try {
        const resultJson = await makePost(operation, submitJSON);
        if (resultJson.statusCode !== 200) {
          this.setState({
            screen: 'error'
          });
        } else {
          const makeMap = resultJson.makes.map(function(makeObj) {
            return { key: makeObj, text: makeObj, value: makeObj };
          });
          this.setState({
            makeArr: makeMap,
            modelArr: [],
            bodyTypeArr: []
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  getAvailableModels = async () => {
    const { year, make } = this.state;
    const submitJSON = {
      year,
      make,
      model: '',
      bodyType: '',
      screen: 'initial'
    };
    if (year !== '' && make !== '') {
      const operation = 'chromedata/fields';

      try {
        const resultJson = await makePost(operation, submitJSON);
        if (resultJson.statusCode !== 200) {
          this.setState({
            screen: 'error'
          });
        } else {
          const modelMap = resultJson.models.map(function(modelObj) {
            return { key: modelObj, text: modelObj, value: modelObj };
          });
          this.setState({
            modelArr: modelMap,
            bodyTypeArr: []
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  getAvailableBodyTypes = async () => {
    const { year, make, model } = this.state;
    const submitJSON = {
      year,
      make,
      model,
      bodyType: '',
      screen: 'initial'
    };
    if (year !== '' && make !== '' && model !== '') {
      const operation = 'chromedata/fields';

      try {
        const resultJson = await makePost(operation, submitJSON);
        if (resultJson.statusCode !== 200) {
          this.setState({
            screen: 'error'
          });
        } else {
          const bodyTypeMap = resultJson.bodyTypes.map(function(bodyTypeObj) {
            return {
              key: bodyTypeObj,
              text: bodyTypeObj,
              value: bodyTypeObj
            };
          });
          this.setState({
            bodyTypeArr: bodyTypeMap
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  updateYear = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        year: key,
        make: '',
        model: '',
        bodyType: ''
      },
      () => {
        this.getAvailableMakes();
      }
    );
  };

  updateMake = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        make: key,
        model: '',
        bodyType: ''
      },
      () => {
        this.getAvailableModels();
      }
    );
  };

  updateModel = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        model: key,
        bodyType: ''
      },
      () => {
        this.getAvailableBodyTypes();
      }
    );
  };

  updateBodyTypes = (e, data) => {
    const key = data.options.find((o) => o.value === data.value).value;
    this.setState(
      {
        bodyType: key
      },
      () => {
        // TODO: Implement enable/disable submit button if necessary
      }
    );
  };

  // eslint-disable-next-line consistent-return
  renderContent = () => {
    const { screen, year, make, model, bodyType } = this.state;
    if (screen === 'preview') {
      return this.state.images.map((img) => {
        return (
          <div key={img}>
            <hr />
            <br />
            <b>
              <p>
                Year: {year} Make: {make} Model: {model} Trim: {bodyType}
              </p>
              <br />
              <p>File:</p>
              <a href={img}>{img}</a>
            </b>
            <br />
            <img
              src={img}
              alt={
                'https://lightwidget.com/wp-content/uploads/2018/05/local-file-not-found-295x300.png'
              }
              style={{ maxWidth: '900px' }}
            />
          </div>
        );
      });
    } else if (screen === 'error') {
      const errorPics = [
        'https://i.redd.it/yevx0e2w79s21.jpg',
        'https://preview.redd.it/g18efekwjcs21.jpg?width=960&crop=smart&auto=webp&s=f99964af18913dacd1f61a8601d3ddc4f02476b8',
        'https://preview.redd.it/mgb3ksrxwbs21.png?width=960&crop=smart&auto=webp&s=54c911e64a840cf1c955c46ede5ace5401fbbc89',
        'https://i.redd.it/1cyrwsub8u211.jpg',
        'https://i.dailymail.co.uk/1s/2019/04/05/07/11830752-6889465-No_religion_here_Kim_Kardashian_West_38_says_her_41_year_old_hus-a-2_1554446953286.jpg',
        'http://www.thestrut.com/wp-content/uploads/2014/02/kanyerant-620x400.jpg',
        'https://preview.redd.it/xewid8aqk2s21.jpg?width=640&crop=smart&auto=webp&s=04734d5752e0aebad8dc1941c0f174cc3f869a71'
      ];

      const randomIndex = Math.floor(
        Math.random() * Math.floor(errorPics.length)
      );
      const randomImg = errorPics[randomIndex];
      return (
        <div key={'1'}>
          <br />
          <h1>
            The vehicle does not exist in ChromeData or an error has occured.
            Here is a picture of Kanye instead.
          </h1>
          <img src={`${randomImg}`} alt={'error.png'} />
        </div>
      );
    }
  };

  renderYearsLoading = () => {
    const { yearsLoading } = this.state;
    if (yearsLoading) {
      return (
        <Dimmer active style={{ width: '100%' }}>
          <Loader content="Loading Available Years Please Wait" />
        </Dimmer>
      );
    }
    return null;
  };

  render() {
    const { vin, yearArr, makeArr, modelArr, bodyTypeArr } = this.state;

    return (
      <Container className="mainChromeContainer">
        {this.renderYearsLoading()}
        <Form>
          <h1>Please Enter A Valid VIN</h1>
          <div className="field">
            <input
              type="text"
              value={vin}
              onChange={this.handleVinChange}
              placeholder="VIN"
            />
          </div>
          <Button secondary width={3} onClick={this.onSubmitButtonClick}>
            Submit
          </Button>
          <h1>Or Enter Year, Make, Model and Trim</h1>
          <div className="field">
            <Dropdown
              search
              searchInput={{ type: 'string' }}
              selection
              options={yearArr}
              placeholder="Year"
              onChange={this.updateYear}
            />
          </div>
          <div className="field">
            <Dropdown
              search
              searchInput={{ type: 'string' }}
              selection
              options={makeArr}
              placeholder="Make"
              onChange={this.updateMake}
            />
          </div>
          <div className="field">
            <Dropdown
              search
              searchInput={{ type: 'string' }}
              selection
              options={modelArr}
              placeholder="Model"
              onChange={this.updateModel}
            />
          </div>
          <div className="field">
            <Dropdown
              search
              searchInput={{ type: 'string' }}
              selection
              options={bodyTypeArr}
              placeholder="Trim"
              onChange={this.updateBodyTypes}
            />
          </div>
          <Button secondary width={3} onClick={this.onSubmitButtonClickYMMT}>
            Submit
          </Button>
          <Button secondary width={3} onClick={this.onClearButtonClick}>
            Clear
          </Button>
        </Form>
        {this.renderContent()}
      </Container>
    );
  }
}

export default connect()(ChromeData);



// WEBPACK FOOTER //
// ./src/screens/ChromeData.js